import Dropdown from './src/dropdown';

Dropdown.install = function(Vue) {
  Vue.component(Dropdown.name, Dropdown);
};

export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/dropdown/index.js